export interface GroupsBackroomState {
  folder?: string;
}

export enum GroupNotesFolderType {
  ARCHIVED = 'archived',
  STARRED = 'starred',
  INBOX = 'inbox',
}
